(function () {
  "use strict";

  // --- painting ------------------------------------------------------------
  // Single source of truth: whatever the last wishlist:changed said.
  function paint(ids) {
    var saved = new Set(ids);

    document.querySelectorAll("[data-wishlist-id]").forEach(function (el) {
      var on = saved.has(String(el.dataset.wishlistId));
      el.classList.toggle("is-saved", on);
      if (el.hasAttribute("aria-pressed")) el.setAttribute("aria-pressed", String(on));

      var label = el.querySelector("[data-wishlist-label]");
      var text = on ? "One of your favorites!" : "Save to favorites";
      // Write only on change: unconditional textContent writes fire the
      // MutationObserver below, which would schedule the next paint forever.
      if (label && label.textContent !== text) label.textContent = text;
      if (el.hasAttribute("aria-label") && el.getAttribute("aria-label") !== text) el.setAttribute("aria-label", text);
      if (el.hasAttribute("title") && el.getAttribute("title") !== text) el.setAttribute("title", text);
    });

    document.querySelectorAll("[data-wishlist-count]").forEach(function (el) {
      var count = String(ids.length);
      if (el.textContent !== count) el.textContent = count;
      el.toggleAttribute("hidden", ids.length === 0);
    });
  }

  document.addEventListener("wishlist:changed", function (event) {
    paint(event.detail.ids);
    if (event.detail.capped) {
      announce("Your favorites list is full, the oldest item was removed.");
    }
  });

  // --- clicks --------------------------------------------------------------
  // Delegated, so hearts inside quick-view modals and re-rendered grids work
  // without re-binding.
  // One toggle in flight per product: rapid double-taps raced the optimistic SDK
  // writes (the slower first response could overwrite the second click's state).
  var inflight = new Set();

  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-wishlist-toggle]");
    if (!button) return;

    event.preventDefault();
    event.stopPropagation(); // don't trigger the card's own link

    var id = button.dataset.wishlistId;
    if (!id || !window.Wishlist) return;
    if (inflight.has(id)) return;
    inflight.add(id);

    button.classList.add("is-pulsing");
    setTimeout(function () { button.classList.remove("is-pulsing"); }, 400);

    Promise.resolve(Wishlist.toggle(id))
      .catch(function () {})
      .finally(function () { inflight.delete(id); });
  });

  // Newly injected markup (quick view, filtered collection re-render) needs a
  // repaint. Cheap enough to run on any DOM change, debounced.
  var repaintTimer = null;
  new MutationObserver(function () {
    clearTimeout(repaintTimer);
    repaintTimer = setTimeout(function () {
      if (window.Wishlist && Wishlist.isReady()) paint(Wishlist.list());
    }, 100);
  }).observe(document.body, { childList: true, subtree: true });

  // --- favorites prefetch --------------------------------------------------
  // Warm the product-data cache from ANY page, so /pages/favourites paints
  // instantly even on its first visit. Refreshed whenever the list changes.
  // The favorites page itself maintains the cache, so skip warming there.
  var CACHE_KEY = "wishlist:products:v1";
  var warmTimer = null;
  function warm() {
    if (!window.Wishlist || !Wishlist.isReady()) return;
    if (document.querySelector("[data-wishlist-grid]")) return;
    var ids = Wishlist.list();
    if (!ids.length) {
      try { sessionStorage.removeItem(CACHE_KEY); } catch (e) {}
      return;
    }
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || "null"); } catch (e) {}
    if (cached && Array.isArray(cached.ids) && cached.ids.join(",") === ids.join(",")) return;
    Wishlist.products().then(function (result) {
      try {
        sessionStorage.setItem(CACHE_KEY, JSON.stringify({
          ids: result.products.map(function (p) { return String(p.id); }),
          products: result.products
        }));
      } catch (e) {}
    });
  }
  document.addEventListener("wishlist:changed", function () {
    clearTimeout(warmTimer);
    warmTimer = setTimeout(warm, 600);
  });

  // If the SDK booted (and fired its one boot event) before this script attached
  // its listener, nothing above has painted yet; catch up immediately.
  if (window.Wishlist && Wishlist.isReady && Wishlist.isReady()) paint(Wishlist.list());

  // --- a11y ----------------------------------------------------------------
  function announce(message) {
    var region = document.getElementById("wishlist-live");
    if (!region) {
      region = document.createElement("div");
      region.id = "wishlist-live";
      region.className = "visually-hidden";
      region.setAttribute("role", "status");
      region.setAttribute("aria-live", "polite");
      document.body.appendChild(region);
    }
    region.textContent = message;
  }
})();
